import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL || 'https://empirecanada.ca/api';

export const PLACEHOLDER_IMAGE_BASE64 = 'data:image/png;base64,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'
export const categoryService = {
  async getCategories() {
    try {
      // Using the endpoint that returns only categories with products
      const response = await axios.get(`${API_URL}/categories`)
      console.log('Categorias recebidas da API:', response.data.length)
      // Returns response.data directly, which is already the array of categories
      return response.data
    } catch (error) {
      console.error('Error fetching categories:', error)
      throw error
    }
  },

  async getAllCategories() {
    try {
      // Endpoint for administrative use that returns all categories
      const response = await axios.get(`${API_URL}/categories/admin/all`)
      return response.data
    } catch (error) {
      console.error('Error fetching all categories:', error)
      throw error
    }
  },

  async getPaginatedCategories(params = {}) {
    try {
      // Endpoint to get paginated categories
      const { page = 1, limit = 10, includeInactive = false, onlyWithProducts = true, search = '' } = params
      // Explicitly convert to string to ensure the backend receives the correct value
      const includeInactiveStr = includeInactive === true ? 'true' : 'false'

      const response = await axios.get(`${API_URL}/categories/paginated`, {
        params: {
          page,
          limit,
          includeInactive: includeInactiveStr, // Pass as string
          onlyWithProducts,
          search
        }
      })
      console.log('[categoryService] Categorias paginadas recebidas:', response.data)
      console.log('[categoryService] Total de categorias:', response.data.total)
      console.log('[categoryService] Total de páginas:', response.data.totalPages)
      return response.data
    } catch (error) {
      console.error('Error fetching paginated categories:', error)
      throw error
    }
  },

  /**
   * Searches categories based on a search term, directly from the backend
   * @param {string} searchTerm - Search term to filter categories
   * @param {boolean} onlyWithProducts - If true, returns only categories with products
   * @returns {Promise<Array>} - Hierarchical list of categories matching the search term
   */
  async searchCategories(searchTerm = '', onlyWithProducts = true) {
    try {
      console.log(`[categoryService] Buscando categorias com termo "${searchTerm}" e onlyWithProducts=${onlyWithProducts}`)

      // Parameters for the search
      const params = {
        search: searchTerm,
        onlyWithProducts: onlyWithProducts,
        includeInactive: false, // Always searches only active categories
        hierarchical: true // Tells the backend to return the hierarchical structure
      }

      // Makes the request to the category search endpoint
      const response = await axios.get(`${API_URL}/categories/search`, { params })

      return response.data
    } catch (error) {
      console.error('Error searching categories:', error)
      throw error
    }
  },

  async updateCategory(id, categoryData) {
    try {
      console.log(`[categoryService] Atualizando categoria ${id} com dados:`, categoryData)
      const response = await axios.patch(`${API_URL}/categories/${id}`, categoryData)
      console.log(`[categoryService] Resposta da API ao atualizar categoria ${id}:`, response.data)
      return response.data
    } catch (error) {
      console.error('Error updating category:', error)
      throw error
    }
  },

  async getTopCategoriesWithMostProducts(limit = 10) {
    try {
      const response = await axios.get(`${API_URL}/categories/top/with-most-products`, {
        params: { limit }
      })
      return response.data
    } catch (error) {
      console.error('Error fetching top categories:', error)
      throw error
    }
  },

  /**
   * Checks whether a category has products directly or through its subcategories
   * @param {Object} category - The category to be checked
   * @param {Object} productCountMap - Map with the product count per category
   * @param {string} parentPath - Hierarchical path of the category (for logging)
   * @returns {boolean} - True if the category has products, false otherwise
   */
  hasCategoryProducts(category, productCountMap = {}, parentPath = '') {
    const currentPath = parentPath ? `${parentPath} > ${category.name}` : category.name

    // Checks whether the category has products directly
    if (productCountMap[category.id] && productCountMap[category.id] > 0) {
      console.log(`[categoryService] ✅ Categoria ${category.name} (ID: ${category.id}) tem ${productCountMap[category.id]} produtos diretamente. Caminho: ${currentPath}`)
      return true
    }

    // Checks whether any subcategory has products
    if (category.children && category.children.length > 0) {
      // Removed unnecessary log about subcategory checking

      let hasProductsInChildren = false
      for (const child of category.children) {
        // Recursive call to check subcategories
        if (this.hasCategoryProducts(child, productCountMap, currentPath)) {
          // Removed unnecessary log about products in subcategories
          hasProductsInChildren = true
          // Does not return immediately so that all subcategories are checked (for logging purposes)
        }
      }

      if (hasProductsInChildren) {
        return true
      }
    }

    console.log(`[categoryService] ❌ Categoria ${category.name} (ID: ${category.id}) não tem produtos nem subcategorias com produtos. Caminho: ${currentPath}`)
    return false
  },

  /**
   * Organizes the categories into a hierarchical structure
   * @param {Array} categories - Flat list of categories
   * @returns {Array} - Hierarchical list of categories
   */
  buildCategoryTree(categories) {
    if (!categories || !categories.length) return []

    // Removed unnecessary log about tree construction

    // First, we create a map of all categories by ID for easy access
    const categoryMap = {}
    categories.forEach(category => {
      // Initializes the children property as an empty array
      categoryMap[category.id] = { ...category, children: [], expanded: false }
    })

    // Then, we build the tree
    const rootCategories = []

    categories.forEach(category => {
      // If the category has a parent_id and that parent exists in the map
      if (category.parent_id && categoryMap[category.parent_id]) {
        // Adds this category as a child of the parent
        categoryMap[category.parent_id].children.push(categoryMap[category.id])
        // Removed unnecessary log about hierarchization
      } else {
        // If it has no parent_id or the parent does not exist, it is a root category
        rootCategories.push(categoryMap[category.id])
        // Removed unnecessary log about hierarchization
      }
    })

    // Removed unnecessary log about root categories
    return rootCategories
  },

  /**
   * Filters the category tree to keep only categories with products
   * @param {Array} categoryTree - Category tree
   * @param {Object} productCountMap - Map with the product count per category
   * @returns {Array} - Filtered category tree
   */
  filterCategoryTree(categoryTree, productCountMap = {}) {
    if (!categoryTree || !categoryTree.length) return []

    // Removed unnecessary log about category filtering

    // Recursive function to filter the tree
    const filterTree = (tree) => {
      return tree.filter(category => {
        // First, filters the children recursively
        if (category.children && category.children.length > 0) {
          category.children = filterTree(category.children)
        }

        // Checks whether the category has products directly
        const hasDirectProducts = productCountMap[category.id] && productCountMap[category.id] > 0

        // Checks whether the category has children with products
        const hasChildrenWithProducts = category.children && category.children.length > 0

        // Keeps the category if it has products directly OR if it has children (which have already been filtered)
        const shouldKeep = hasDirectProducts || hasChildrenWithProducts

        // Removed unnecessary logs about keeping/removing categories

        return shouldKeep
      })
    }

    const filteredTree = filterTree(categoryTree)
    // Removed unnecessary log about filtered tree

    return filteredTree
  },

  /**
   * Marks the categories as expanded when a specific category is selected
   * @param {Array} categoryTree - Category tree
   * @param {String} selectedCategoryId - ID of the selected category
   * @returns {Array} - Category tree with the categories expanded
   */
  expandCategoriesForSelected(categoryTree, selectedCategoryId) {
    if (!categoryTree || !categoryTree.length || !selectedCategoryId) return categoryTree;

    // Removed unnecessary log about category expansion

    // Creates a deep copy of the tree so as not to modify the original
    const treeCopy = JSON.parse(JSON.stringify(categoryTree));

    // Recursive function to mark the categories as expanded
    const markExpandedCategories = (tree, targetId, path = []) => {
      for (const category of tree) {
        // Adds the current category to the path
        const currentPath = [...path, category];

        // Checks whether the current category is the selected category
        if (category.id === targetId) {
          // Marks all categories in the path as expanded
          for (const pathCategory of currentPath) {
            pathCategory.expanded = true;
          }
          return true;
        }

        // If the category has children, checks recursively
        if (category.children && category.children.length > 0) {
          const found = markExpandedCategories(category.children, targetId, currentPath);
          if (found) {
            return true;
          }
        }
      }

      return false;
    };

    // Marks the categories as expanded
    markExpandedCategories(treeCopy, selectedCategoryId);

    return treeCopy;
  }
}



